// /pages/FleetManagement/Drivers/AddDriverPage.tsx
import React from 'react';
import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { DriverForm } from '@/components/forms/DriverForm';
import { useThemeColors } from '@/hooks/useThemeColors';

const AddDriverPage = () => {
    const navigate = useNavigate();
    const colors = useThemeColors();

    const handleBack = () => navigate('/fleet-management/drivers');

    return (
        <AdminLayout>
            {/* 1. Outer container: Forced full height, hidden overflow, flex column */}
            <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
                
                {/* 2. Card: h="full" and flex column to partition header and body */}
                <Card h="full" display="flex" flexDirection="column" variant="outline" boxShadow="sm">
                    
                    {/* 3. Header: Stays fixed at the top */}
                    <CardHeader py={4} borderBottom="1px" borderColor="gray.100" flexShrink={0}>
                        <Heading size="md" mb={1}>Add New Driver</Heading>
                        <Text fontSize="sm" color="gray.500">
                            Register a new driver to the fleet system.
                        </Text>
                    </CardHeader>
                    
                    {/* 4. Body: Only this section scrolls (overflowY="auto") */}
                    <CardBody py={6} overflowY="auto" flex="1" minH={0}>
                        <DriverForm 
                            onSuccess={handleBack} 
                            onCancel={handleBack} 
                        />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
};

export default AddDriverPage;